<template>
  <v-container id="negocios" tag="section">
    <base-v-component heading="Negocios del Sistema" />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{
          formTitle
        }}</v-btn>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="getNegocios">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
        <!--DIALOGO EDITAR-->
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="nombre"
                      label="Nombre"
                      :error-messages="nombreErrors"
                      @input="$v.nombre.$touch()"
                      @blur="$v.nombre.$touch()"
                      ref="nombreReferencia"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="telefono"
                      label="Telefono"
                      :error-messages="telefonoErrors"
                      @input="$v.telefono.$touch()"
                      @blur="$v.telefono.$touch()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm8>
                    <v-text-field
                      v-model="email"
                      label="Email"
                      :error-messages="emailErrors"
                      @input="$v.email.$touch()"
                      @blur="$v.email.$touch()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                      v-model="cif"
                      label="CIF"
                      :error-messages="cifErrors"
                      @input="$v.cif.$touch()"
                      @blur="$v.cif.$touch()"
                    ></v-text-field>
                  </v-flex>
                  <v-col cols="6">
                    <v-text-field
                      v-model="direccionFiscal"
                      label="Dirección Fiscal"
                      :error-messages="direccionErrors"
                      @input="$v.direccionFiscal.$touch()"
                      @blur="$v.direccionFiscal.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="provinciasSelects"
                      label="Codigo Provincia"
                      multiple
                      :items="provincias"
                      :search-input.sync="searchSelect"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="cocinasSelect"
                      label="Tipos de cocinas"
                      multiple
                      :items="cocinas"
                      :search-input.sync="searchSelectTipoCocina"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-if="!imagenSrc"
                      accept="image/*"
                      label="Logo"
                      v-model="imagen"
                    ></v-file-input>
                    <template v-else>
                      <v-row align="center" justify="center">
                        <v-col cols="4">
                          <v-img :src="imagenSrc" width="65px"></v-img>
                        </v-col>
                        <v-col cols="4">
                          <v-btn text @click="imagenSrc = null"
                            >Cambiar Imagen</v-btn
                          >
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-if="!imagenSrcListado"
                      accept="image/*"
                      label="Imagen para el listado del negocio"
                      v-model="imagenListado"
                    ></v-file-input>
                    <template v-else>
                      <v-row align="center" justify="center">
                        <v-col cols="4">
                          <v-img :src="imagenSrcListado" width="465px"></v-img>
                        </v-col>
                        <v-col cols="4">
                          <v-btn text @click="imagenSrcListado = null"
                            >Cambiar Imagen</v-btn
                          >
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                </v-layout>
                <v-row>
                  <v-col cols="6">
                    <v-checkbox v-model="printNode" label="Printnode" />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox v-model="mapeoNeo" label="MapeoNeo" />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox v-model="vromo" label="Vromo" />
                  </v-col>
                </v-row>
                <template v-if="mapeoNeo">
                  <v-row dense>
                    <v-col cols="12">
                      <v-select
                        v-model="mapeoNeoRestaurante"
                        :items="selectRestaurantes"
                        label="Restaurante matriz"
                        messages="Se tomarán los datos para el mapeo global de este restaurante"
                      />
                    </v-col>
                  </v-row>
                </template>
                <template v-if="printNode">
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        v-model="keyPrintNode"
                        :append-icon="
                          showKeyPrintNode ? 'mdi-eye' : 'mdi-eye-off'
                        "
                        :type="showKeyPrintNode ? 'text' : 'password'"
                        @click:append="showKeyPrintNode = !showKeyPrintNode"
                        label="Apikey Printnode"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <v-row v-if="vromo" dense>
                  <v-col cols="12">
                    <v-text-field label="Vromo apikey" v-model="vromoApikey" />
                  </v-col>
                  <!-- <v-col cols="12" sm="6">
                    <v-autocomplete
                      label="Grupo Vromo"
                      v-model="vromoGroup"
                      :items="vromoGroupsSelect"
                    />
                  </v-col> -->
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--DIALOGO EMAIL-->
        <v-dialog v-model="emails.dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline"
                >Emails del negocio {{ emails.negocio }}</span
              >
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="emailNotComputados"
                      label="Emails notificaciones"
                      placeholder="Separados por comas"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="emailInternosComputados"
                      label="Emails pedidos internos"
                      placeholder="Separados por comas"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="emailsReservasComputados"
                      label="Emails reservas internos"
                      placeholder="Separados por comas"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeEmails"
                >Cancelar</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="saveEmails"
                :loading="emails.loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--DIALOGO FACTURACIÓN-->
        <v-dialog v-model="dialogFacturacion.dialog" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline"
                >Facturación del Negocio {{ dialogFacturacion.negocio }}</span
              >
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-select
                      :loading="dialogFacturacion.loadingForm"
                      label="Modo de facturación"
                      :items="$store.state.facturacion.modoFacturacion"
                      v-model="facturacion.modoFacturacion"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    v-if="facturacion.modoFacturacion == 'negocio'"
                  >
                    <v-select
                      :loading="dialogFacturacion.loadingForm"
                      label="Impuesto facturación concepto online"
                      :items="$store.getters['impuestos/getImpuestosSelect']"
                      v-model="facturacion.impuesto"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    v-if="facturacion.modoFacturacion == 'negocio'"
                  >
                    <v-text-field
                      :loading="dialogFacturacion.loadingForm"
                      v-model="facturacion.cuentaAsociada"
                      label="Id cuenta asociada Stripe"
                      append-icon="mdi-link"
                      prepend-icon="mdi-delete"
                      @click:append="abrirEnlaceStripe"
                      @click:prepend="borrarCuentaStripe"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="facturacion.modoFacturacion == 'negocio'">
                  <v-card width="50%" class="mx-auto">
                    <v-list-item>
                      <v-list-item-avatar color="primary">
                        <v-icon class="white--text">mdi-currency-eur</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="headline"
                          >TASAS PAGO ONLINE</v-list-item-title
                        >
                        <v-list-item-subtitle
                          >Se aplica a cada pago online y se retiene a la hora
                          de pasarlo a su cuenta asociada</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            type="number"
                            step="0.01"
                            label="Porcentaje por pedido pago online"
                            v-model="facturacion.tasaPorcentajePedidoPagoOnline"
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            type="number"
                            step="0.01"
                            label="Valor fijo por pedido pago online"
                            v-model="facturacion.tasaFijaPedidoPagoOnline"
                          />
                        </v-col>
                      </v-row>
                      <!--tasaPorcentajePedido: 0,tasaFijaPedido: 0,tasaFijaServicio: 0-->
                    </v-card-text>
                  </v-card>
                  <v-card width="50%" class="mx-auto">
                    <v-list-item>
                      <v-list-item-avatar color="primary">
                        <v-icon class="white--text">mdi-currency-eur</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="headline"
                          >TASAS PEDIDO</v-list-item-title
                        >
                        <v-list-item-subtitle
                          >Se aplica a cada pedido y se facturará al terminar el
                          periodo</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            type="number"
                            step="0.01"
                            label="Porcentaje por pedido"
                            v-model="facturacion.tasaPorcentajePedido"
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            type="number"
                            step="0.01"
                            label="Valor fijo por pedido pago online"
                            v-model="facturacion.tasaFijaPedido"
                          />
                        </v-col>
                      </v-row>
                      <!--tasaPorcentajePedido: 0,tasaFijaPedido: 0,tasaFijaServicio: 0-->
                    </v-card-text>
                  </v-card>
                </v-row>
                <v-divider />
                <v-row v-if="facturacion.modoFacturacion == 'negocio'">
                  <v-card width="100%">
                    <v-card-title>Datos Facturación</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="4">
                          <v-text-field label="CIF" v-model="facturacion.cif" />
                        </v-col>
                        <v-col cols="12" sm="8">
                          <v-text-field
                            label="Nombre"
                            v-model="facturacion.nombre"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            v-model="facturacion.direccion"
                            label="Dirección"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="facturacion.cp"
                            label="Código postal"
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="facturacion.municipio"
                            label="Municipio"
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="facturacion.provincia"
                            label="Provincia"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="emailsFacturacionComputados"
                            label="Emails de envio (separados por comas)"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-row>
                <!-- imágenes facturación -->
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-row class="mx-2">
                      <p class="text-center subtitle-1">Imagen Logo</p>
                      <v-spacer />
                      <v-btn
                        :loading="loadingImagenAux"
                        small
                        class="red mr-4"
                        v-if="facturacion.imagenLogo"
                        @click="facturacion.imagenLogo = ''"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-btn
                        :loading="loadingImagenAux"
                        small
                        class="secondary"
                        @click="cambiarImagen('imagenLogo')"
                      >
                        <v-icon>mdi-reload</v-icon>
                      </v-btn>
                      <v-file-input
                        class="d-none"
                        ref="imagenLogo"
                        color="deep-purple accent-4"
                        counter
                        label="File input"
                        placeholder="Imagen logo"
                        prepend-icon="mdi-paperclip"
                        outlined
                        v-model="imagenAux"
                        @change="cambiarImagenFichero('facturacion')"
                        :show-size="1000"
                      />
                    </v-row>

                    <v-img :src="facturacion.imagenLogo" max-height="150px" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-row class="mx-2">
                      <p class="text-center subtitle-1">Imagen marca de agua</p>
                      <v-spacer />
                      <v-btn
                        :loading="loadingImagenAux"
                        small
                        class="red mr-4"
                        v-if="facturacion.imagenMarcaAgua"
                        @click="facturacion.imagenMarcaAgua = ''"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-btn
                        :loading="loadingImagenAux"
                        small
                        class="secondary"
                        @click="cambiarImagen('imagenMarcaAgua')"
                      >
                        <v-icon>mdi-reload</v-icon>
                      </v-btn>
                      <v-file-input
                        class="d-none"
                        ref="imagenMarcaAgua"
                        color="deep-purple accent-4"
                        counter
                        label="File input"
                        placeholder="Imagen logo"
                        prepend-icon="mdi-paperclip"
                        outlined
                        v-model="imagenAux"
                        @change="cambiarImagenFichero('facturacion')"
                        :show-size="1000"
                      />
                    </v-row>

                    <v-img
                      :src="facturacion.imagenMarcaAgua"
                      max-height="150px"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeFacturacion"
                >Cancelar</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="saveFacturacion"
                :loading="dialogFacturacion.loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="negocios"
        :loading="loading"
        :search="search"
        disable-pagination
      >
        <template v-slot:item.imagen="{ item }">
          <v-img
            v-if="item.imagen"
            :src="item.imagen"
            aspect-ratio="1"
            width="65px"
          ></v-img>
          <span v-else>sin imagen</span>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="yellow"
                  min-width="0"
                  small
                  v-on="on"
                  @click="facturacionDialog(item)"
                >
                  <v-icon class="black--text" small>mdi-currency-eur</v-icon>
                </v-btn>
              </template>
              <span>Configurar facturación</span>
            </v-tooltip>

            <v-btn
              class="px-2 ml-1"
              color="blue"
              min-width="0"
              small
              @click="emailDialog(item)"
            >
              <v-icon small>mdi-email</v-icon>
            </v-btn>
            <v-btn
              class="px-2 ml-1"
              color="success"
              min-width="0"
              small
              @click="editItemDialog(item)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              class="px-2 ml-1"
              color="red"
              min-width="0"
              small
              @click="deleteItem(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import { createSlug } from '@/utils/utils.js';
  import { validationMixin } from 'vuelidate';
  import {
    required,
    maxLength,
    email,
    minLength,
    numeric,
  } from 'vuelidate/lib/validators';
  import { mapState, mapGetters } from 'vuex';
  export default {
    mixins: [validationMixin],
    validations: {
      email: { required, email },
      telefono: { minLength: minLength(4), numeric },
      nombre: { required },
      direccionFiscal: { required, minLength: minLength(8) },
      cif: { required, minLength: minLength(8) },
    },
    data: () => ({
      dialogFacturacion: {
        dialog: false,
        id: '',
        negocio: '',
        loadingForm: false,
      },
      facturacion: {
        modoFacturacion: null,
        impuesto: null,
        cuentaAsociada: '',
        tasaPorcentajePedidoPagoOnline: 0,
        tasaFijaPedidoPagoOnline: 0,
        tasaPorcentajePedido: 0,
        tasaFijaPedido: 0,
        tasaFijaServicio: 0,
        nombre: '',
        cif: '',
        direccion: '',
        cp: '',
        municipio: '',
        provincia: '',
        emails: [],
      },
      loadingForm: false,
      loading: false,
      dialog: false,
      search: '',
      id: null,
      nombre: '',
      direccionFiscal: '',
      provinciasSelects: [],
      searchSelect: '',
      cocinasSelect: [],
      searchSelectTipoCocina: '',
      cif: '',
      telefono: '',
      email: '',
      imagen: null,
      imagenSrc: null,
      imagenListado: null,
      imagenSrcListado: null,
      showKeyPrintNode: false,
      keyPrintNode: '',
      selectRestaurantes: [],
      printNode: false,
      mapeoNeo: false,
      vromo: false,
      // vromoGroup: "",
      vromoApikey: '',
      mapeoNeoRestaurante: false,
      emails: {
        dialog: false,
        notificaciones: [],
        reservas: [],
        internos: [],
        id: null,
        nombre: '',
        loadingForm: false,
      },
      headers: [
        {
          sortable: false,
          text: 'Imagen',
          value: 'imagen',
        },
        {
          sortable: false,
          text: 'Nombre',
          value: 'nombre',
        },
        {
          sortable: false,
          text: 'Telefono',
          value: 'telefono',
        },
        {
          sortable: false,
          text: 'Acciones',
          value: 'acciones',
          align: 'right',
        },
      ],
      imagenCambiando: null,
      loadingImagenAux: false,
      imagenAux: null,
    }),
    computed: {
      emailsFacturacionComputados: {
        get() {
          return this.facturacion.emails
            ? this.facturacion.emails.toString().trim()
            : '';
        },
        set(val) {
          var expresionRegular = /\s*,\s*/;
          this.facturacion.emails = val.split(expresionRegular);
        },
      },
      emailInternosComputados: {
        get() {
          return this.emails.internos ? this.emails.internos.toString() : '';
        },
        set(val) {
          var expresionRegular = /\s*,\s*/;
          this.emails.internos = val.split(expresionRegular);
        },
      },
      emailsReservasComputados: {
        get() {
          return this.emails.reservas ? this.emails.reservas.toString() : '';
        },
        set(val) {
          var expresionRegular = /\s*,\s*/;
          this.emails.reservas = val.split(expresionRegular);
        },
      },
      emailNotComputados: {
        get() {
          return this.emails.notificaciones
            ? this.emails.notificaciones.toString()
            : '';
        },
        set(val) {
          var expresionRegular = /\s*,\s*/;
          this.emails.notificaciones = val.split(expresionRegular);
        },
      },
      telefonoErrors() {
        const errors = [];
        if (!this.$v.telefono.$dirty) return errors;
        !this.$v.telefono.numeric && errors.push('Sólo números.');
        !this.$v.telefono.minLength && errors.push('Telefono demasiado corto.');
        return errors;
      },
      direccionErrors() {
        const errors = [];
        if (!this.$v.direccionFiscal.$dirty) return errors;
        !this.$v.direccionFiscal.required &&
          errors.push('Dirección obligatoria.');
        !this.$v.direccionFiscal.minLength && errors.push('Demasiado corto.');
        return errors;
      },
      emailErrors() {
        const errors = [];
        if (!this.$v.email.$dirty) return errors;
        !this.$v.email.email && errors.push('Must be valid e-mail');
        !this.$v.email.required && errors.push('E-mail es obligatorio');
        return errors;
      },
      cifErrors() {
        const errors = [];
        if (!this.$v.cif.$dirty) return errors;
        !this.$v.cif.required && errors.push('El cif es requerido');
        !this.$v.cif.minLength && errors.push('Demasiado corto.');
        return errors;
      },
      nombreErrors() {
        const errors = [];
        if (!this.$v.nombre.$dirty) return errors;
        !this.$v.nombre.required && errors.push('Nombre es obligatorio');
        return errors;
      },
      ...mapState({
        negocios: (state) => state.negocios.negociosArray,
        provincias: (state) => state.negocios.provinciasSelect,
      }),
      ...mapGetters({
        cocinas: 'cocinas/selectCocinas',
      }),
      formTitle() {
        return this.isEdit ? 'Editar Negocio' : 'Nuevo Negocio';
      },
      accion() {
        return this.id ? 'edit' : 'add';
      },
      isAdd() {
        return this.accion == 'add';
      },
      isEdit() {
        return this.accion == 'edit';
      },
      // vromoGroupsSelect() {
      //   return this.$store.state.vromo.groups.map((g) => {
      //     return {
      //       value: g.id,
      //       text: g.name,
      //     };
      //   });
      // },
    },
    watch: {
      // vromo(v) {
      //   if (v) {
      //     this.$store.dispatch("vromo/getGroups");
      //   }
      // },
      dialog(val) {
        val || this.close();
      },
      'emails.dialog'(val) {
        val || this.closeEmails();
      },
      'dialogFacturacion.dialog'(val) {
        val || this.closeFacturacion();
      },
    },
    methods: {
      deleteItem(item) {
        let r = confirm('¿Quieres eliminar el negocio? (no se puede deshacer)');
        if (r) {
          this.loading = true;
          let _vm = this;
          this.$store
            .dispatch('negocios/deleteNegocio', item.id)
            .then((res) => {
              _vm.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Negocio eliminada',
              });
              _vm.getNegocios();
            })
            .catch((error) => {
              _vm.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Error al eliminar',
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
      borrarCuentaStripe() {
        this.loadingStripe = true;
        let _vm = this;
        let r = confirm('¿Quieres eliminar la cuenta? (no se puede deshacer)');
        if (r) {
          return this.$store
            .dispatch('negocios/borrarCuentaStripe', this.dialogFacturacion.id)
            .then((r) => {
              if (r.data && r.data.ok) {
                // window.open(r.data.url, "_blank");
                alert('ok, o yo que se ya');
              }
            })
            .finally(() => {
              _vm.loadingStripe = false;
            });
        }
      },
      abrirEnlaceStripe() {
        this.loading = true;
        let _vm = this;
        return this.$store
          .dispatch('negocios/enlaceStripe', this.dialogFacturacion.id)
          .then((r) => {
            if (r.data && r.data.ok) {
              window.open(r.data.url, '_blank');
            }
            console.log(r);
          })
          .finally(() => {
            _vm.loading = false;
          });
      },
      getNegocios() {
        this.loading = true;
        let _vm = this;
        return this.$store.dispatch('negocios/getNegocios').finally(() => {
          _vm.loading = false;
        });
      },
      showDialog() {
        this.dialog = true;
        //this.$nextTick(this.$refs.nombreReferencia.focus())
      },
      close() {
        this.dialog = false;
        this.$v.$reset();
        let _vm = this;
        setTimeout(() => {
          _vm.reiniciarDatos();
        }, 300);
      },
      reiniciarDatos() {
        this.nombre = '';
        this.email = '';
        this.telefono = '';
        this.imagen = null;
        this.imagenSrc = null;
        this.imagenListado = null;
        this.imagenSrcListado = null;
        this.id = null;
        this.cif = '';
        this.direccionFiscal = '';
        this.showKeyPrintNode = false;
        this.keyPrintNode = '';
        this.selectRestaurantes = [];
        this.provinciasSelects = [];
        this.cocinasSelect = [];
        this.printNode = false;
        this.mapeoNeo = false;
        this.mapeoNeoRestaurante = false;
        this.vromo = false;
        this.vromoApikey = '';
        // this.vromoGroup = "";
      },
      addNegocio() {
        let negocio = {
          email: this.email,
          nombre: this.nombre,
          cif: this.cif,
          direccion: this.direccionFiscal,
          imagen: this.imagen,
          imagenListado: this.imagenListado,
          provincias: this.provinciasSelects.map((e) => parseInt(e)),
          cocinas: this.cocinasSelect ? this.cocinasSelect : [],
          id: this.id ? this.id : createSlug(this.nombre),
          printNode: this.printNode ? this.printNode : false,
          keyPrintNode: this.keyPrintNode ? this.keyPrintNode : false,
          vromo: this.vromo ? this.vromo : false,
          mapeoNeo: this.mapeoNeo ? this.mapeoNeo : false,
          mapeoNeoRestaurante: this.mapeoNeoRestaurante
            ? this.mapeoNeoRestaurante
            : null,
          cod: this.cod,
        };
        if (this.vromo) {
          // negocio.vromoGroup = this.vromoGroup;
          negocio.vromoApikey = this.vromoApikey;
        }
        if (this.telefono) negocio.telefono = this.telefono;
        return this.$store.dispatch('negocios/addNegocio', negocio);
      },
      async editItemDialog(item) {
        this.nombre = item.nombre;
        this.email = item.email;
        this.imagenSrc = item.imagen;
        this.imagenSrcListado = item.imagenListado;
        this.telefono = item.telefono;
        this.id = item.id;
        (this.direccionFiscal = item.direccion), (this.cif = item.cif);
        this.dialog = true;
        this.cod = item.cod;
        this.showKeyPrintNode = false;
        this.keyPrintNode = item.secreto ? item.secreto.keyPrintNode : '';
        this.vromoApikey = item.secreto ? item.secreto.vromoApikey : '';
        this.vromo = item.vromo ? item.vromo : false;
        // this.vromoGroup = item.vromoGroup ? item.vromoGroup : "";
        this.printNode = item.printNode;
        this.mapeoNeo = item.mapeoNeo;
        this.cocinasSelect = item.cocinas;
        this.provinciasSelects = item.provincias
          ? item.provincias.map((e) => ('0' + e).slice(-2))
          : [];
        this.mapeoNeoRestaurante = item.mapeoNeoRestaurante;
        let select = await this.$store.dispatch(
          'negocios/getRestaurantesNegocio',
          item
        );
        select.unshift({
          value: null,
          text: '-- No centralizado --',
        });
        this.selectRestaurantes = select;
      },
      async facturacionDialog(item) {
        this.dialogFacturacion.dialog = true;
        this.dialogFacturacion.negocio = item.nombre;
        this.dialogFacturacion.id = item.id;
        this.dialogFacturacion.loadingForm = true;
        const datosFact = await this.$store.dispatch(
          'negocios/getFacturacion',
          this.dialogFacturacion.id
        );
        this.dialogFacturacion.loadingForm = false;
        if (datosFact) this.facturacion = datosFact;
      },
      async emailDialog(item) {
        this.emails.dialog = true;
        this.emails.negocio = item.nombre;
        this.emails.id = item.id;
        const emails = await this.$store.dispatch(
          'negocios/getEmails',
          this.emails.id
        );
        this.emails.internos = emails ? emails.internos : [];
        this.emails.notificaciones = emails ? emails.notificaciones : [];
        this.emails.reservas = emails ? emails.reservas : [];
      },
      saveEmails() {
        const _vm = this;
        _vm.emails.loadingForm = true;
        this.$store
          .dispatch('negocios/saveEmails', {
            id: this.emails.id,
            emails: {
              internos: this.emails.internos ? this.emails.internos : [],
              reservas: this.emails.reservas ? this.emails.reservas : [],
              notificaciones: this.emails.notificaciones
                ? this.emails.notificaciones
                : [],
            },
          })
          .then((r) => {
            _vm.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Emails grabados con éxito',
            });
            this.closeEmails();
          })
          .catch((error) => {
            _vm.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al guardar los emails',
            });
          })
          .finally(() => {
            _vm.emails.loadingForm = false;
          });
      },
      closeEmails() {
        this.emails.dialog = false;
        this.emails.negocio = '';
        this.emails.id = null;
        this.emails.internos = [];
        this.emails.reservas = [];
        this.emails.notificaciones = [];
      },
      save() {
        let _vm = this;
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.loadingForm = true;
          if (this.isAdd || this.isEdit) {
            this.addNegocio()
              .then((res) => {
                _vm.$store.commit('snackbar/setMensajeSuccess', {
                  msj: 'Negocio grabado con éxito',
                });
                _vm.getNegocios();
                _vm.dialog = false;
              })
              .catch((error) => {
                console.log(error);
                _vm.$store.commit('snackbar/setMensajeDanger', {
                  msj: 'Error al guardar el negocio',
                });
              })
              .finally(() => {
                _vm.loadingForm = false;
              });
          }
        }
      },
      saveFacturacion() {
        const _vm = this;
        _vm.dialogFacturacion.loadingForm = true;
        this.$store
          .dispatch('negocios/saveFacturacion', {
            id: this.dialogFacturacion.id,
            facturacion: this.facturacion,
          })
          .then((r) => {
            _vm.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Datos de facturación grabados con éxito',
            });
            this.closeFacturacion();
          })
          .catch((error) => {
            _vm.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al guardar los datos de facturación',
            });
          })
          .finally(() => {
            _vm.dialogFacturacion.loadingForm = false;
          });
      },
      closeFacturacion() {
        this.dialogFacturacion = {
          dialog: false,
          id: '',
          negocio: '',
          loadingForm: false,
        };
        this.facturacion = {
          modoFacturacion: null,
          cuentaAsociada: '',
        };
      },
      cambiarImagen(s) {
        this.imagenCambiando = s;
        this.$refs[s].$refs.input.click();
      },
      cambiarImagenFichero(pagina) {
        let _vm = this;
        _vm.loadingImagenAux = true;
        this.$store
          .dispatch('propio/subirImagen', {
            //tipo: this.imagenCambiando,
            imagen: this.imagenAux,
          })
          .then((img) => {
            const array = pagina.split('/');
            let aux = this;
            array.forEach((e) => {
              aux = aux[e];
            });
            aux[this.imagenCambiando] = img;
          })
          .finally(() => (_vm.loadingImagenAux = false));
      },
    },
    mounted() {},
  };
</script>

<style></style>
